/**
 * UserSettings — per-user self-service settings page.
 *
 * Currently hosts the Notifications preferences section. Lives under
 * `/settings/notifications` behind ProtectedRoute (not AdminRoute), so
 * every authenticated user — including non-admins — can manage their own
 * preferences. AdminSettings (`/admin/settings`) remains the admin-only
 * platform-wide configuration surface.
 */

import { AccountInfoSettings } from '../components/settings/AccountInfoSettings';
import { ChangePasswordSettings } from '../components/settings/ChangePasswordSettings';
import { NotificationsSettings } from '../components/settings/NotificationsSettings';

export function UserSettings() {
  return (
    <>
      <AccountInfoSettings />
      <ChangePasswordSettings />
      <NotificationsSettings />
    </>
  );
}
